module.exports = __webpack_public_path__ + "img/sv15.d73c3378.svg";